module.exports = __webpack_public_path__ + "static/media/Team 22 - The Elite Group.c59e10e3.jpg";